import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const loadVendors = createAsyncThunk(
  'vendors/loadVendors',
  async ({ page = 1, searchValue = '', page_size = 15 }, { rejectWithValue }) => {
    try {
      let url = `vendors/vendor/?page=${page}&page_size=${page_size}`;
      if (searchValue) url += `&search=${searchValue}`;
      const response = await axios.get(url);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const vendorsSlice = createSlice({
  name: 'vendors',
  initialState: {
    vendors: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadVendors.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadVendors.fulfilled, (state, action) => {
        state.loading = false;
        state.vendors = action.payload;
      })
      .addCase(loadVendors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default vendorsSlice.reducer;
